import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-analytics-team-allowances',
    templateUrl: './analytics-team-allowances.component.html',
    styleUrls: ['./analytics-team-allowances.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AnalyticsTeamAllowancesComponent {
  @Input() analytics: any;
}
